import { render, staticRenderFns } from "./ProductInputSuggest.vue?vue&type=template&id=76c39880&scoped=true&"
import script from "./ProductInputSuggest.vue?vue&type=script&lang=js&"
export * from "./ProductInputSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c39880",
  null
  
)

export default component.exports